import userAgentHelper from '@/library/userAgentHelper'
import "./initPre"
import authorizeMogo from "./authorizeMogo"
import authorizeUnion from "./authorizeUnion"
import authorizeAli from "./authorizeAli"
import authorizeWeiXin from "./authorizeWeiXin"
import authorizeMogoApp from "./authorizeMogoApp"
import store from '@/store';


// 已有code ，获取授权信息
function _doCode() {
  if (userAgentHelper.browser == userAgentHelper.BrowserEnum.UNIONPAY) {
    return authorizeUnion.doCode();
  } else if (userAgentHelper.browser === userAgentHelper.BrowserEnum.WEI_XIN) {
    return authorizeWeiXin.doCode();
  } else if (userAgentHelper.browser === userAgentHelper.BrowserEnum.ALI) {
    return authorizeAli.doCode();
  }
}
let authorizeManage = {
  // 去授权
  doAuth(config, error) {
    if (userAgentHelper.browser === userAgentHelper.BrowserEnum.UNIONPAY) {
      authorizeUnion.doAuth();// 银联登录
    } else if (userAgentHelper.browser === userAgentHelper.BrowserEnum.WEI_XIN) {
      authorizeWeiXin.doAuth(); // 微信登录
    } else if (userAgentHelper.isAliMini()) {
      window.my && window.my.postMessage({ type: 'login', data: { url: location.href } }); // 支付宝小程序登陆
    } else if (userAgentHelper.browser === userAgentHelper.BrowserEnum.ALI) {
      authorizeAli.doAuth(); // 支付宝登录
    } else if (userAgentHelper.browser === userAgentHelper.BrowserEnum.MGRenter) {
      // 蘑菇app登录
      authorizeMogoApp.doAuth().then(auth => {
        store.dispatch('setAuth', auth);
      }).catch(e => {
        error && error(e)
      })
    } else {
      authorizeMogo.doAuth(config);// 蘑菇登录
      store.dispatch('setAuthPending', false);
    }
  },
  doCode() {
    let temp = _doCode();
    if(temp) {
      temp.then(auth => {
        store.dispatch('setAuth', auth);
      }).catch(data => {
        store.dispatch('errorAuth', data);
      })
    }
  }

}
export default authorizeManage;



// WEBPACK FOOTER //
// ./src/store/modules/authorizeHelper/authorizeManage.js